goog.provide('el8.app.settings.typeSettings');

goog.require('el8.data.apptTypes');
goog.require('el8.data.reportTypes');
goog.require('el8.data.currUser');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.visitNoteTypes');
goog.require('el8.service.tooltip');
goog.require('el8.template.app.settings.typeSettings');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.titleFreeConfirm');


/**
 * Customizing appointment types, visit note types, and report types
 */
el8.app.settings.typeSettings = (function() {

    var $container;

    var that = {

        init: function(_container) {
            $container = _container;
            $container.html(el8.template.app.settings.typeSettings.content());

            setupVisitTypeList($container);
            setupReportTypeList($container);

            setupHeaderTooltips();

            bindTriggers($container);
        }
    };

    function bindTriggers($container) {
        // set current toggle state
        var additionalVitalsEnabled = el8.data.practiceSettings.isAdditionalVitalsEnabled();
        $(':input[name="additionalVitalsEnabled"]', $container)
            .filter('[value="'+additionalVitalsEnabled+'"]')
            .prop('checked', true);

        $container.on('change', ':input[name="additionalVitalsEnabled"]',  function() {
            var msgElt = $('.confirm-msg', $('#additional-vitals-toggle-section'));
            el8.data.practiceSettings.updateAdditionalVitalsEnabled(
                $(this).val() === 'true' ? true : false,
                function() { el8.app.settings.util.handleSavedMsg(msgElt); }
            );
        });
    }

    function setupVisitTypeList($container) {
        new el8.uiwidget.CuratedList({
            entitySet: el8.data.visitNoteTypes,
            confirmDeletes: true,
            container: $('.visit-type-section', $container),
            listSelector: '.visit-type-list',
            listTemplateFn: function() {
                return el8.template.app.settings.typeSettings.visitTypeList({
                    visitTypes: el8.data.visitNoteTypes.sortedAsSoyMaps()
                });
            },
            preRenderFn: function($listContainer) {
                el8.service.tooltip.destroy(
                    $('.default-visit-tooltip', $listContainer)
                );
            },
            postRenderFn: function($listContainer) {
                // this tooltip needs to be created and destroyed every time we redraw the list,
                // since .default-visit-tooltip will have been removed/recreated
                el8.service.tooltip.create({
                    anchor: $('.default-visit-tooltip', $listContainer),
                    text: el8.template.app.settings.typeSettings.defaultVisitTooltip()
                });
            },
            formTemplateFn: el8.template.app.settings.typeSettings.visitTypeForm,
            fieldSpec: [
                {
                    name: 'name',
                    selector: ':input[name="name"]',
                    infoText: 'New visit note type name',
                    maxLength: 50,
                    validate: {
                        required: true
                    }
                },
                {
                    name: 'isMuOfficeVisit',
                    selector: ':input[name="isMuOfficeVisit"]',
                    castToBool: true
                }
            ],
            itemDescriptionStr: 'note type',
            saveFn: function(form, $elem) {
                if (!form.isValid()) { return; }
                var that = this;

                var item;
                var elemId = $elem.data('id');
                if (elemId) {
                    item = el8.data.visitNoteTypes.getById(elemId);
                } else {
                    item = el8.data.visitNoteTypes.create({}, true);
                }

                // We're going to check if this edited the isMuOfficeVisit value. If so,
                // we'll have a special confirmation for the user. Otherwise, we'll just save.
                var doSave = function() {
                    item.populate(form.getMapped());
                    el8.data.visitNoteTypes.saveItem(item, false, {
                        errorCb: function(item, xhrData) {
                            if (xhrData.status === 409) {
                                el8.uiwidget.alert('This '+that._itemDescriptionStr+' already exists. ' +
                                    'Please edit the existing ' + that._itemDescriptionStr +
                                    ' or pick a new name.');
                            } else {
                                el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                            }
                        }
                    });
                };

                var oldMuValue = item.isMuOfficeVisit();
                var newMuValue = form.getVal('isMuOfficeVisit');
                if (item.getId() && oldMuValue !== newMuValue) {
                    el8.uiwidget.titleFreeConfirm({
                        msgTemplateFn: function() {
                            return el8.template.app.settings.typeSettings.visitTypeMuChangeConfirmation({
                                isMuOfficeVisit: newMuValue
                            });
                        },
                        yesFn: function() { doSave(); },
                        yesBtnText: 'Yes, save changes',
                        noBtnText: 'Cancel',
                        prefHeight: 250
                    });
                } else {
                    doSave();
                }
            },
            customDeleteFn: function(item) {
                el8.uiwidget.titleFreeConfirm({
                    msgTemplateFn: function() {
                        return el8.template.app.settings.typeSettings.visitTypeDeleteConfirmation({
                            visitType: item.asSoyMap()
                        });
                    },
                    yesFn: function() { el8.data.visitNoteTypes.deleteItem(item); },
                    yesBtnText: 'Yes, remove it',
                    noBtnText: 'Cancel'
                });
            }
        }).init();
    }

    function setupReportTypeList($container) {
        new el8.uiwidget.CuratedList({
            entitySet: el8.data.reportTypes,
            itemDescriptionStr: 'report type',
            confirmDeletes: true,
            reRenderOnSort: true, // re-render our rows and our tab preview
            container: $('.report-type-section', $container),
            listSelector: '.report-type-list',
            listTemplateFn: function() {
                return el8.template.app.settings.typeSettings.reportTypeList({
                    groupedReportTypes: el8.data.reportTypes.groupedSoyMaps()
                });
            },
            formTemplateFn: function() {
                var allTypes = _.values(el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY);
                // if there's a practice-local copy already, we don't want to provide the option to add it again
                var unusedTypes = allTypes.filter(function(type) {
                    var practiceLocalCopy = el8.data.reportTypes.getById(type.id, true); // local-cache only
                    return !Boolean(practiceLocalCopy); // filter for practiceLocalCopy is falsy
                });
                unusedTypes.sort(function(a, b) { return a.user_label.localeCompare(b.user_label); });
                return el8.template.app.settings.typeSettings.reportTypeForm({
                    availableTypes: el8.util.keysFromUnderscoreToCamel(unusedTypes)
                });
            },
            fieldSpec: [
                {
                    name: 'reportTypeId',
                    selector: ':input[name="reportTypeId"]',
                    chosenOpts: {
                        allow_single_deselect: true
                    },
                    validate: {
                        required: true
                    }
                }
            ],
            saveFn: function(form, $elem) {
                if (!form.isValid()) { return; }
                var typeId = form.getVal('reportTypeId');

                var doSave = function() {
                    $.el8_ajax({
                        type: 'POST',
                        url: el8.service.urls.get('reportTypes', [typeId]),
                        success: function(data) {
                            el8.data.reportTypes.create(data);
                        }
                    });
                };

                if (isOrderLinkedReportTab(typeId)) {
                    var rType = el8.util.keysFromUnderscoreToCamel(
                        el8Globals.AVAILABLE_REPORT_TYPES[typeId]
                    );
                    var confirmMsg = el8.template.app.settings.typeSettings.reportTypeAddOrderTabConfirmation(rType);
                    el8.uiwidget.confirm(confirmMsg, doSave);
                } else {
                    doSave();
                }
            },
            customDeleteFn: function(item) {
                var soyMap = item.asSoyMap();
                $.extend(soyMap, { isOrderLinked: isOrderLinkedReportTab(item.getId()) });
                var confirmMsg = el8.template.app.settings.typeSettings.reportTypeDeleteTabConfirmation(soyMap);
                el8.uiwidget.confirm(confirmMsg, function() { el8.data.reportTypes.deleteItem(item); });
            }
        }).init();
    }

    function setupHeaderTooltips() {
        el8.service.tooltip.create({
            anchor: $('.visit-note-type-tooltip', $container),
            text: el8.template.app.settings.typeSettings.visitNoteTypeTooltip()
        });
        el8.service.tooltip.create({
            anchor: $('.mu-office-visit-tooltip', $container),
            text: el8.template.app.settings.typeSettings.muOfficeVisitTooltip()
        });
    }

    function isOrderLinkedReportTab(rTypeId) {
        var rType = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId];
        return _.contains(el8.util.consts.ORDER_TYPES, rType.report_type_label.toLowerCase());
    }

    return that;

})();
